import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import BodyView from '@/components/BodyView.vue'
import AuthView from '@/auth/AuthView.vue'
import LoginPage from '@/auth/LoginPage.vue'
import AdminLoginPage from '@/auth/admin/AdminLoginPage.vue'
import PlaceholderPage from '@/pages/PlaceholderPage.vue'
import TenantDashboard from '@/pages/dashboard/TenantDashboard.vue'
import AdminDashboard from '@/pages/admin/AdminDashboard.vue'
import AdminCompanies from '@/pages/admin/AdminCompanies.vue'
import AdminUsers from '@/pages/admin/AdminUsers.vue'
import TenantUsers from '@/pages/administration/TenantUsers.vue'
import TenantClients from '@/pages/administration/TenantClients.vue'
import Matters from '@/pages/court/Matters.vue'
import Documents from '@/pages/court/Documents.vue'
import CourtDiary from '@/pages/court/CourtDiary.vue'
import Invoices from '@/pages/accounts/Invoices.vue'
import Receipts from '@/pages/accounts/Receipts.vue'
import TrustAccounts from '@/pages/accounts/TrustAccounts.vue'
import Payments from '@/pages/accounts/Payments.vue'
import Billing from '@/pages/accounts/Billing.vue'
import TenantSettings from '@/pages/Settings.vue'

function tenantPage(path, name, breadcrumbMain, breadcrumbTitle) {
  return {
    path,
    name,
    component: PlaceholderPage,
    meta: {
      title: `${breadcrumbTitle} | Wakili`,
      requiresAuth: true,
      authScope: 'tenant',
      breadcrumbMain,
      breadcrumbTitle,
    },
  }
}

const routes = [
  {
    path: '/auth',
    component: AuthView,
    meta: { requiresAuth: false },
    children: [
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          title: 'Login | Wakili',
          requiresAuth: false,
          authScope: 'tenant',
        },
      },
    ],
  },
  {
    path: '/admin/auth',
    component: AuthView,
    meta: { requiresAuth: false },
    children: [
      {
        path: 'login',
        name: 'admin-login',
        component: AdminLoginPage,
        meta: {
          title: 'Admin Login | Wakili',
          requiresAuth: false,
          authScope: 'admin',
        },
      },
    ],
  },
  {
    path: '/admin',
    component: BodyView,
    meta: { requiresAuth: true, authScope: 'admin' },
    children: [
      {
        path: '',
        redirect: { name: 'admin-dashboard' },
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: {
          title: 'Admin Dashboard | Wakili',
          requiresAuth: true,
          authScope: 'admin',
        },
      },
      {
        path: 'companies',
        name: 'admin-companies',
        component: AdminCompanies,
        meta: {
          title: 'Companies | Wakili Admin',
          requiresAuth: true,
          authScope: 'admin',
        },
      },
      {
        path: 'users',
        name: 'admin-users',
        component: AdminUsers,
        meta: {
          title: 'Admin Users | Wakili Admin',
          requiresAuth: true,
          authScope: 'admin',
        },
      },
    ],
  },
  {
    path: '/',
    name: 'home',
    component: BodyView,
    meta: { requiresAuth: true, authScope: 'tenant' },
    children: [
      {
        path: 'dashboard',
        name: 'tenant-dashboard',
        component: TenantDashboard,
        meta: {
          title: 'Dashboard | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
        },
      },
      {
        path: 'administration/users',
        name: 'administration-users',
        component: TenantUsers,
        meta: {
          title: 'Users | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Admin',
          breadcrumbTitle: 'Users',
        },
      },
      {
        path: 'administration/clients',
        name: 'administration-clients',
        component: TenantClients,
        meta: {
          title: 'Clients | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Admin',
          breadcrumbTitle: 'Clients',
        },
      },
      {
        path: 'court/matters',
        name: 'court-matters',
        component: Matters,
        meta: {
          title: 'Matters | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Court',
          breadcrumbTitle: 'Matters',
        },
      },
      {
        path: 'court/documents',
        name: 'court-documents',
        component: Documents,
        meta: {
          title: 'Documents | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Court',
          breadcrumbTitle: 'Documents',
        },
      },
      {
        path: 'court/diary',
        name: 'court-diary',
        component: CourtDiary,
        meta: {
          title: 'Court Diary | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Court',
          breadcrumbTitle: 'Court Diary',
        },
      },
      {
        path: 'accounts/invoices',
        name: 'accounts-invoices',
        component: Invoices,
        meta: {
          title: 'Invoices | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Accounts',
          breadcrumbTitle: 'Invoices',
        },
      },
      {
        path: 'accounts/receipts',
        name: 'accounts-receipts',
        component: Receipts,
        meta: {
          title: 'Receipts | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Accounts',
          breadcrumbTitle: 'Receipts',
        },
      },
      {
        path: 'accounts/trust-accounts',
        name: 'accounts-trust-accounts',
        component: TrustAccounts,
        meta: {
          title: 'Trust Accounts | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Accounts',
          breadcrumbTitle: 'Trust Accounts',
        },
      },
      {
        path: 'accounts/billing',
        name: 'accounts-billing',
        component: Billing,
        meta: {
          title: 'Billing | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Accounts',
          breadcrumbTitle: 'Billing',
        },
      },
      {
        path: 'accounts/payments',
        name: 'accounts-payments',
        component: Payments,
        meta: {
          title: 'Payments | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Accounts',
          breadcrumbTitle: 'Payments',
        },
      },
      tenantPage('reports/chart-of-accounts', 'reports-chart-of-accounts', 'Reports', 'Chart of Accounts'),
      tenantPage('reports/court-diary', 'reports-court-diary', 'Reports', 'Court Diary'),
      tenantPage('reports/income-statement', 'reports-income-statement', 'Reports', 'Income Statement'),
      tenantPage('reports/trial-balance', 'reports-trial-balance', 'Reports', 'Trial Balance'),
      tenantPage('reports/profit-and-loss', 'reports-profit-and-loss', 'Reports', 'Profit & Loss'),
      tenantPage('reports/balance-sheet', 'reports-balance-sheet', 'Reports', 'Balance Sheet'),
      tenantPage('reports/audit-trail', 'reports-audit-trail', 'Reports', 'Audit Trail'),
      {
        path: 'settings',
        name: 'settings',
        component: TenantSettings,
        meta: {
          title: 'Settings | Wakili',
          requiresAuth: true,
          authScope: 'tenant',
          breadcrumbMain: 'Settings',
          breadcrumbTitle: 'Settings',
        },
      },
    ],
  },
  { path: '', redirect: { name: 'tenant-dashboard' } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

function isAdminScope(route) {
  return route.matched.some((record) => record.meta.authScope === 'admin')
}

router.beforeEach((to, from, next) => {
  if (typeof to.meta.title === 'string') {
    document.title = to.meta.title
  }

  const adminScope = isAdminScope(to)
  const isAuthenticated = adminScope
    ? store.getters['adminAuth/isAuthenticated']
    : store.getters['auth/isAuthenticated']
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth !== false)

  if (requiresAuth && !isAuthenticated) {
    return next({
      name: adminScope ? 'admin-login' : 'login',
      query: { redirect: to.fullPath },
    })
  }

  if (to.name === 'admin-login' && store.getters['adminAuth/isAuthenticated']) {
    return next({ name: 'admin-dashboard' })
  }

  if (to.name === 'login' && store.getters['auth/isAuthenticated']) {
    return next({ name: 'tenant-dashboard' })
  }

  return next()
})

export default router
